//noScroll
class Modaal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

  function modalClick() {

    const changeText01 = document.querySelectorAll(".modaal-interview__item01")
    const changeText02 = document.querySelectorAll(".modaal-interview__item02")
    const changeContent01 = document.querySelectorAll(".modaal-content01")
    const changeContent02 = document.querySelectorAll(".modaal-content02")
    let changeTtl01;
    let changeTtl02;

    changeText01.forEach(text => {
      text.addEventListener("click", () => {
        changeText01.forEach(allChecks => {
          if(allChecks.classList.contains("is-active")){
            allChecks.classList.remove("is-active")
          }
        });

        text.classList.add("is-active")
        changeTtl01 = text.dataset.ttl;

        changeContent01.forEach(el => {
          el.style.display = "none";
          if(el.dataset.ttl == changeTtl01){
            el.style.display = "block";
          }
        })
      })
    });


    changeText02.forEach(text => {
      text.addEventListener("click", () => {
        changeText02.forEach(allChecks => {
          if(allChecks.classList.contains("is-active")){
            allChecks.classList.remove("is-active")
          }
        });
        text.classList.add("is-active")
        changeTtl02 = text.dataset.ttl;

        changeContent02.forEach(el => {
          el.style.display = "none";
          if(el.dataset.ttl == changeTtl02){
            el.style.display = "block";
          }
        })
      })
    });

  }
  function clickEvent(){
    const career = document.querySelectorAll(".job-career__btn.selet-btn");
    const jobKind = document.querySelectorAll(".job-kind__btn");
    const stylist = document.querySelector(".js-stylist");


    career.forEach(item => {
      item.addEventListener("click", () => {
        career.forEach(allChecks => {
          if(allChecks.classList.contains("is-active")){
            allChecks.classList.remove("is-active")
          }
        });
        item.classList.add("is-active")
      })

    });

    jobKind.forEach(item => {
      item.addEventListener("click", () => {
        jobKind.forEach(allChecks => {
          if(allChecks.classList.contains("is-active")){
            allChecks.classList.remove("is-active")
          }
        });
        item.classList.add("is-active")
        if(item === career[0]  && item.classList.contains("is-active") && jobKind[0].classList.contains("is-active")){
          stylist.textContent = "aaa";
        }
      })
    });
  }

  function selectEvent(){

    const jobContent = document.querySelectorAll('.job-content');
    const careerBtn = document.querySelectorAll('.job-career__btn');
    const kindBtn = document.querySelectorAll('.job-kind__btn');
    let career;
    let job;


    $(".job-career input, .job-kind input").on("click", function() {
      careerBtn.forEach(function(el) {
      if(el.classList.contains("is-active")) {
        career = el.getAttribute('value');
        }
      })
      kindBtn.forEach(function(el) {
      if(el.classList.contains("is-active")) {
        job = el.getAttribute('value');
      }
      })
      jobContent.forEach(function(el) {
      el.style.display = "none";
      if(career == el.getAttribute("data-recruit") && job == el.getAttribute("data-job")) {
        el.style.display = "flex";
      }
      })


      })

  }

  modalClick();

  clickEvent();

  selectEvent();



  $(".modaal-01").modaal({
    content_source: '#modaal-01',
    animation_speed: '1000',
    background: '#333',
    background_scroll: true,
    overlay_opacity: '0.3',

});
  $(".modaal-02").modaal({
    content_source: '#modaal-02',
    animation_speed: '1000',
    background: '#333',
    background_scroll: false,
    overlay_opacity: '0.3',
});




  }


}
